// Tab Drawer Search Close

document.addEventListener("DOMContentLoaded", function () {
  const tabDrawer = document.querySelector(".tab-drawer");
  const searchBar = tabDrawer.querySelector(".js-search-header");

  searchBar.addEventListener("click", function () {
    tabDrawer.querySelector(".drawer__close-button").click();
  });
});

// Tab Menu Script

document.addEventListener("DOMContentLoaded", () => {
  if (!customElements.get("tab-container")) {
    class TabContainer extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        const tabButtons = this.querySelectorAll(".tab-button");

        tabButtons.forEach((tabButton) => {
          // Use a common function to handle both click and touch events
          const handleTabInteraction = (event) => {
            event.preventDefault();
            event.stopPropagation();
            const currentTabContentId =
              tabButton.getAttribute("data-tab-content");
            const currentTabContent = this.querySelector(currentTabContentId);

            // Remove 'is-active' class from all tab buttons
            tabButtons.forEach((button) => {
              button.classList.remove("is-active");
            });

            // Add 'is-active' class to the clicked tab button
            tabButton.classList.add("is-active");

            // Remove 'is-active' class from all tab contents
            this.querySelectorAll(".tab-content").forEach((tabContent) => {
              tabContent.classList.remove("is-active");
            });

            // Add 'is-active' class to the corresponding tab content
            currentTabContent.classList.add("is-active");
          };

          // Attach both click and touch event listeners to the button
          tabButton.addEventListener("click", handleTabInteraction);
          tabButton.addEventListener("touchstart", handleTabInteraction);
        });
      }
    }

    customElements.define("tab-container", TabContainer);
  }
});

// Tab Color Slider Script

document.addEventListener("DOMContentLoaded", () => {
  const tabContainer = document.querySelector(".tab-drawer .tab__drawer-body");
  const tabSlider = tabContainer.querySelector(".tab-color_slider");
  var TabSwiper = new Swiper(tabSlider, {
    slidesPerView: 8,
    spaceBetween: 5,
    grid: {
      rows: 2,
    },
    clickable: true,
    navigation: {
      nextEl: ".swiper-button.swiper-button-next",
      prevEl: ".swiper-button.swiper-button-prev",
    },
  });
});